<template>
  <div>
    <div
      v-bind:class="{ 'message-mine': isMessageMine }"
      v-on:click.right="handleMessageShowContextMenu"
      class="message-container"
    >
      <div v-if="isText" class="message message-text">
        <!--          <span v-html="translated" />-->
        <span
          v-for="(snippet, idx) of parseText(translated)"
          :key="`${message.sid}-${idx}`"
        >
          <span v-if="snippet.type === 'text'">{{ snippet.text }}</span>
          <a
            style="color: white"
            v-if="snippet.type === 'link'"
            target="_blank"
            :href="`//${snippet.text}`"
            >{{ snippet.text }}</a
          >
        </span>
        <small v-if="isMessageTranslated" class="translated-from"
          ><br /><i>"{{ translatedFromExcerpt }}"</i></small
        >
      </div>
      <div v-if="isImage" class="message message-image">
        <img
          v-bind:src="thumbnailUrl"
          @click="() => onImageClick(message)"
          @error="imageLoadError"
          @load="imageLoadSuccess"
          width="calculateWidth"
          height="calculateHeight"
        />
      </div>
      <div v-if="isVideo" class="message message-image">
        <video
          class="message-video"
          @mouseover="videoMouseOver($event.target)"
          @mouseout="videoMouseOut($event.target)"
          style="max-width: 400px; max-height: 400px; border-radius: 15px; background-color: rgba(255,255,255,.1)"
          @error="videoLoadError"
          @load="imageLoadSuccess"
          @loadedmetadata="
            () => {
              // alert('...')
            }
          "
        >
          <source :src="thumbnailUrl" :type="videoType" />
        </video>
        <div v-if="showVideoDownload" class="video-fail-text">
          <span
            >Video not playing? <a :href="thumbnailUrl">Download here.</a></span
          >
        </div>
      </div>
      <div v-if="isFile" class="message message-text">
        <a
          :href="fileDownloadUrl"
          target="_blank"
          style="color: inherit !important; text-align: center; text-decoration: none;"
        >
          <v-icon x-large style="color: inherit !important;"
            >mdi-file-document</v-icon
          >
          <span>{{ friendlyFileName }}</span>
        </a>
      </div>
      <Reactions
        v-if="reactionsList.length > 0"
        :user-reactions-summary="reactionsSummary"
        :user-reactions="reactionsList"
        :message-id="message.sid"
        :align="isMessageMine ? 'right' : 'left'"
      />
      <div v-if="signature !== null" class="signature">
        {{ signature }}
        <v-progress-circular
          v-if="isImage && sending"
          size="18"
          color="blue"
          :value="sendProgress"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import {
  isFile,
  isImage,
  isText,
  isVideo,
  mediaUrl,
  momentFriendly,
  videoType
} from "../../helpers/chat";
import { REACTIONS } from "@/helpers/chat";
import Reactions from "./Reactions";
import { react } from "@/helpers/api";

export default Vue.extend({
  name: "ChatMessage",
  components: { Reactions },
  props: [
    "user",
    "users",
    "message",
    "previousMessage",
    "nextMessage",
    "language",
    "chatClient",
    "onImageClick"
  ],
  data: function() {
    return {
      author: null,
      participant: null,
      imageErrorRetryCount: 0,
      showDelete: false,
      sending: false,
      progress: 0,
      reactionSelector: false,
      reactionsSummary: {},
      reactionsList: [],
      x: 0,
      y: 0,
      showVideoDownload: false
    };
  },
  async mounted() {
    // @see chat.js/createSendingMessage()
    if (this.message.isTemp) {
      this.sending = true;
      this.progress = this.message.progress;
      setInterval(() => {
        this.progress = this.message.progress;
      }, 500);
    } else {
      this.participant = await this.message.getParticipant();
      this.author = await this.participant.getUser();
    }
    this.calculateReactions();
  },
  computed: {
    fileDownloadUrl() {
      if (!this.message) return null;
      return `/rest-api/chat/file/${this.message.conversation.attributes.organizationId}/${this.message.conversation.sid}/${this.message.body}`;
    },
    translated() {
      // if (this.language !== "") {
      //   let val = this.message.attributes["language-" + this.language];
      //   if (!val) {
      //     this.translate();
      //     val = this.message.body;
      //   }
      //   return val;
      // } else {
      return this.message.body;
      // }
    },
    showTranslate() {
      let show = true;
      if (this.language) {
        const val = this.message.attributes["language-" + this.language];
        show = !val;
      }
      return show;
    },
    friendlyFileName() {
      let fileName =
        this.message.isTemp && this.message.media
          ? "Uploading File..."
          : this.message.body;
      if (fileName) {
        const pos = fileName.indexOf("_");
        fileName = pos === -1 ? fileName : fileName.substring(pos + 1);
      }
      return fileName;
    },
    isMessageTranslated() {
      return this.translated !== this.message.body;
    },
    isMessageMine() {
      return this.message.author === this.user.id;
    },
    signature() {
      if (this.sending) return "Sending ";

      // if there's a next message...
      if (
        this.nextMessage &&
        // ...and it was written by me...
        this.nextMessage.author === this.message.author &&
        // ...and it was sent less than two minutes apart...
        this.nextMessage.dateCreated.getTime() -
          this.message.dateCreated.getTime() <=
          120000
      ) {
        return null;
      } else {
        const authorName =
          this.message.author !== this.user.id
            ? this.author !== null
              ? this.author.friendlyName
              : null
            : null;
        return (
          (authorName ? authorName + ", " : "") +
          momentFriendly(this.message.dateCreated)
        );
      }
    },
    translatedFromExcerpt() {
      const max = 75;
      if (this.message.body.length > max) {
        return this.message.body.substr(0, max) + " ...";
      } else {
        return this.message.body;
      }
    },
    isText() {
      return isText(this.message);
    },
    isImage() {
      return isImage(this.message);
    },
    isVideo() {
      return isVideo(this.message);
    },
    isFile() {
      return isFile(this.message);
    },
    videoType() {
      return videoType(this.message);
    },
    thumbnailUrl() {
      return mediaUrl(this.message);
    },
    sendProgress() {
      return parseInt(this.progress * 100, 10);
    }
  },
  methods: {
    handleMessageShowContextMenu(e) {
      e.preventDefault();
      this.$emit("showContextMenu", e, this.message);
    },
    calculateWidth() {
      return 250;
    },
    calculateHeight() {
      const aspectRatio =
        this.message &&
        this.message.attributes.width &&
        this.message.attributes.height
          ? this.message.attributes.height / this.message.attributes.width
          : 0.82;

      return this.calculateWidth() * aspectRatio;
    },
    onAction() {
      if (this.isImage) {
        alert("Opening image...");
      } else if (this.isVideo) {
        alert("Opening video...");
      }
    },
    parseText(text) {
      const expression = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w-]*)?(\?[^\s]*)?/gi;
      const regex = new RegExp(expression);
      let match = "";
      const splitText = [];
      let startIndex = 0;
      while ((match = regex.exec(text)) != null) {
        splitText.push({
          text: text.substr(startIndex, match.index - startIndex),
          type: "text"
        });

        let cleanedLink = text.substr(match.index, match[0].length);
        cleanedLink = cleanedLink.replace(/^https?:\/\//, "");
        splitText.push({ text: cleanedLink, type: "link" });

        startIndex = match.index + match[0].length;
      }
      if (startIndex < text.length)
        splitText.push({ text: text.substr(startIndex), type: "text" });
      return splitText;
    },
    calculateReactions() {
      if (this.message.attributes) {
        //Reset reactions for live updates to message
        this.reactionsList = [];
        this.reactionsSummary = {};

        const reactionsAttr = this.message.attributes["reactions"] || {};

        for (const [userId, userReaction] of Object.entries(reactionsAttr)) {
          // update list of user reactions
          userReaction.userId = userId; // store in the userReaction object as convenience
          this.reactionsList.push(userReaction);

          // update reaction count in summary
          const reactionCount = this.reactionsSummary[userReaction.reaction];

          this.reactionsSummary[userReaction.reaction] = reactionCount
            ? reactionCount + 1
            : 1;
        }

        this.reactionsSummary = { ...this.reactionsSummary };
        // sort reactions list to group by reaction
        this.reactionsList = this.reactionsList.sort((a, b) => {
          this.reactionSortValue(a) - this.reactionSortValue(b);
        });
      }
    },
    reactionSortValue(userReaction) {
      return (
        REACTIONS.sortOrder(userReaction.reaction) + userReaction.friendlyName
      );
    },
    translate() {
      // todo: add logic to only translate text messages, no sense in burdening the server.
      const url =
        "/rest-api/chat/translate-message/" +
        this.message.conversation.sid +
        "/" +
        this.message.sid +
        "/" +
        this.language;
      axios.get(url); // no need to get response, Twilio should file update event
    },
    remove() {
      this.message.remove();
    },
    videoLoadError() {
      this.showVideoDownload = true;
    },
    imageLoadError() {
      if (this.imageErrorRetryCount < 1) {
        setTimeout(() => {
          this.imageErrorRetryCount = this.imageErrorRetryCount + 1;
        }, 1000);
      } else {
        this.showDelete = true;
      }
    },
    imageLoadSuccess() {
      if (this.message.addedAfterMount || this.sending)
        this.$el.scrollIntoView({ behavior: "smooth" });
    },
    videoMouseOver(that) {
      console.log("mouseOver");
      that.setAttribute("controls", "controls");
      this.showVideoDownload = true;
    },
    videoMouseOut(that) {
      console.log("mouseOut");
      that.removeAttribute("controls");
      setTimeout(() => {
        if (this.showVideoDownload) this.showVideoDownload = false;
      }, 2000);
    }
  },
  watch: {
    "message.attributes": function() {
      this.calculateReactions();
    }
  }
});
</script>
<style>
.message-container {
  position: relative;
  margin-bottom: 2px;
}

.message-container.message-mine {
  text-align: right;
}

.message {
  display: inline-block;
}

.message-mine .message {
  text-align: right;
}

.message.message-text {
  color: white;
  border: 1px solid rgb(67, 85, 100);
  background: rgb(67, 85, 100);
  padding: 7px 10px;
  border-radius: 10px 10px 10px 0;
  max-width: 80%;
  overflow-wrap: break-word;
}

.message.message-text .translated-from {
  font-style: italic;
  opacity: 0.6;
}

.message-mine .message.message-text {
  border: 1px solid dodgerblue;
  background: dodgerblue;
  color: white;
  border-radius: 10px 10px 0 10px;
}

.message.message-image img {
  max-width: 400px;
  max-height: 400px;
  border-radius: 10px 10px 10px 0;
}

.message-mine .message.message-image img {
  border-radius: 10px 10px 0 10px;
}

.message-container .signature {
  font-size: 85%;
  color: #888;
  padding-bottom: 10px;
}

.video-fail-text span {
  opacity: 0.6;
  color: white;
  transition: all 0.5s ease-in-out;
}

.video-fail-text a {
}

.message-video {
  max-width: 400px;
  max-height: 400px;
  border-radius: 15px;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
